/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { WalletV2 } from "./WalletV2";
import * as t from "io-ts";

// required attributes
const DeletedWalletsR = t.interface({});

// optional attributes
const DeletedWalletsO = t.partial({
  deletedWallets: t.Integer,

  notDeletedWallets: t.Integer,

  remainingWallets: t.readonlyArray(WalletV2, "array of WalletV2")
});

export const DeletedWallets = t.intersection(
  [DeletedWalletsR, DeletedWalletsO],
  "DeletedWallets"
);

export type DeletedWallets = t.TypeOf<typeof DeletedWallets>;
